/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import "core-js/stable";
import "regenerator-runtime/runtime";

window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Mixin
import gv from './mixins/GlobalVariables'
Vue.mixin(gv)

//VModal（モーダルウィンドウ）
import VModal from 'vue-js-modal'
Vue.use(VModal)

//Vuelidate（フォームバリデーション）
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

//VueScrollTo（アンカーリンクのスクロールアニメーション）
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)

//文字数制限のグローバルフィルタ（ホントは全角半角でいい感じにしたい・・・）
Vue.filter('truncate', function(value, length, omission) {
    var length = length ? parseInt(length, 10) : 20;
    var ommision = omission ? omission.toString() : '…';
    if (value.length <= length) {
        return value;
    }
    return value.substring(0, length) + ommision;
});

// 改行をbr変換
Vue.component('nl2br', {
    functional: true,
    props: ['tag','text'],
    render: function (createElement, context) {
      return createElement(context.props.tag,
        context.props.text.split("\n").reduce(function(x,y){
            if (!Array.isArray(x)){
              return [x,createElement('br'),y];
            }
            return x.concat([createElement('br'),y]);
        }));
    }
  });

/**
 * Global observable variables
 */
const coords = Vue.observable({
    isAvailable : null,
    latitude: 0,
    longitude: 0,
    geoDistance: 0,
});
Object.defineProperty(Vue.prototype, '$coords', {
    get () { return coords },
    set (value) { coords = value }
});
Object.defineProperty(Vue.prototype, '$coordsAvailability', {
    get () { return coords.isAvailable },
    set (value) { coords.isAvailable = value }
});
Object.defineProperty(Vue.prototype, '$coordsGeoDistance', {
    get () { return coords.geoDistance },
    set (value) { coords.geoDistance = value }
});

/**
 * vue-spinner
 */
Vue.component('pulse-loader', require('vue-spinner/src/PulseLoader.vue').default);
Vue.component('beat-loader', require('vue-spinner/src/BeatLoader.vue').default);

/* /home/index.blade.php */
Vue.component('main-slide-component', require('./components/MainSlider.vue').default);
Vue.component('geolocation-component', require('./components/GeoLocation.vue').default);
Vue.component('distance-salon-slide-component', require('./components/Salons.vue').default);
Vue.component('distance-post-slide-component', require('./components/Posts.vue').default);
Vue.component('campaign-list-component', require('./components/CampaignList.vue').default);

/* /post/saerch.blade.php */
Vue.component('search-box-component', require('./components/SearchBox.vue').default);
Vue.component('search-box-title', require('./components/SearchTitle.vue').default);
Vue.component('posts-archive-component', require('./components/PostsArchive.vue').default);
Vue.component('member-archive-component', require('./components/MemberArchive.vue').default);

/* /salon/detail.blade.php */
Vue.component('salon-page-main-component', require('./components/SalonPageMain.vue').default);

/* /post/saerch.blade.php */
Vue.component('contact-form-component', require('./components/ContactForm.vue').default);

/* ad banner */
Vue.component('ad-banner-component', require('./components/AdBanner.vue').default);

/* /information/about.blade.php */
Vue.component('posts-official-archive-component', require('./components/PostsOfficialArchive.vue').default);

const app = new Vue({
    el: '#app'
});